import { createFetcherBase } from './util';
export * from '@kcuf/fetcher';
export { createFetcherBase };
export default createFetcherBase();
//# sourceMappingURL=index.js.map